import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsistenciaMenuComponent } from './asistencia-menu.component';
import { BasecomponentsModule } from '../../basecomponents/basecomponents.module';

@NgModule({
  imports: [
    CommonModule,
    BasecomponentsModule
  ],
  exports: [
    AsistenciaMenuComponent
  ],
  declarations: [AsistenciaMenuComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AsistenciaMenuModule { }
